"use restrict";
const logoSliderOptions = {
  autoScroll: {
    speed: 0.4,
  },
  drag: "free",
  mediaQuery: "min",
  type: "loop",
  arrows: false,
  pagination: false,
  perPage: 4,
  perMove: 1,
  gap: 20,
  breakpoints: {
    768: {
      perPage: 5,
      perMove: 1,
      gap: 72
    }
  },
};

const logoSlider = new Splide("#ae--logo-slider", logoSliderOptions);
logoSlider.mount(window.splide.Extensions);
